
module.exports = function register(BoringInjections) {

  return {
    runOrder: 1000,
    baseDir: __dirname,
    run: async (params) => {

    },
  };
};

